import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import IncidentUpdateRequestDetails from "./IncidentUpdateRequestDetails";
import IncidentUpdateRequestHeader from "./IncidentUpdateRequestHeader";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import {
  loadIncidentUpdateRequestAsync,
  selectIncidentUpdateRequest,
} from "../../../redux/slices/incidentUpdateRequest";
import Page500 from "../../../pages/auth/Page500";

const IncidentUpdateRequest = () => {
  const [loading, setLoading] = useState(false);
  const [loadingIncidentUpdateRequestId, setLoadingIncidentUpdateRequestId] =
    useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const incidentUpdateRequestSelector = useAppSelector(
    selectIncidentUpdateRequest
  );

  const dispatch = useAppDispatch();

  let { profileNo, incidentUpdateRequestId } = useParams();
  if (!profileNo || !incidentUpdateRequestId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingIncidentUpdateRequestId !== incidentUpdateRequestId) {
    setLoadingIncidentUpdateRequestId(incidentUpdateRequestId);
    dispatch(loadIncidentUpdateRequestAsync(incidentUpdateRequestId));
    return <Loading />;
  }

  const incidentUpdateRequestDetails =
    incidentUpdateRequestSelector.incidentUpdatRequest;

  if (!incidentUpdateRequestDetails) {
    return <Loading />;
  }

  if (!incidentUpdateRequestDetails.response.ok) {
    if (incidentUpdateRequestDetails.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <IncidentUpdateRequestHeader
            licenceProfile={licenceProfile}
            incidentUpdateRequestDetails={incidentUpdateRequestDetails}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <IncidentUpdateRequestDetails
            incidentUpdateRequestDetails={incidentUpdateRequestDetails}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            incidentUpdateRequestDetails={incidentUpdateRequestDetails}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        incidentUpdateRequestDetails={incidentUpdateRequestDetails}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default IncidentUpdateRequest;
